"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var baseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: none;\n  appearance: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease-in-out;\n"], ["\n  outline: none;\n  appearance: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease-in-out;\n"])));
exports.default = baseStyles;
var templateObject_1;
